/**
 * Returns if the user id for the user who referred the current one.
 * @param {Object} user
 * @returns {Number?}
 */
var getFreeTrialReferrerId = function (user) {
    return user && user.advocate_id ? user.advocate_id : null;
};
/**
 * Returns if the user is eligible for the referral free trial. Should only occur if they used
 * a referral code.
 * @param {Object} user
 * @param {boolean} isEligible Response from FT Eligiblity endpoint
 * @returns {Boolean}
 */
var isEligibleForReferralFreeTrial = function (user, isEligible) {
    return Boolean(isEligible && getFreeTrialReferrerId(user) !== null);
};

var RoleIDs;
(function (RoleIDs) {
    RoleIDs[RoleIDs["ADMINISTRATOR"] = 4] = "ADMINISTRATOR";
    RoleIDs[RoleIDs["PREMIUM_PLUS"] = 6] = "PREMIUM_PLUS";
    RoleIDs[RoleIDs["PREMIUM_STANDARD"] = 7] = "PREMIUM_STANDARD";
    RoleIDs[RoleIDs["B2B"] = 25] = "B2B";
    // only allowed to access the payment
    RoleIDs[RoleIDs["SANDBOX"] = 28] = "SANDBOX";
    RoleIDs[RoleIDs["ADMIN_B2B"] = 29] = "ADMIN_B2B";
    // @deprecated: use premium role with expiry instead
    RoleIDs[RoleIDs["CURRENTLY_IN_FREE_TRIAL"] = 32] = "CURRENTLY_IN_FREE_TRIAL";
    // @deprecated: use premium role with expiry instead
    RoleIDs[RoleIDs["PREVIOUSLY_IN_FREE_TRIAL"] = 33] = "PREVIOUSLY_IN_FREE_TRIAL";
    RoleIDs[RoleIDs["MARKETING"] = 34] = "MARKETING";
    RoleIDs[RoleIDs["DEVELOPER"] = 35] = "DEVELOPER";
    RoleIDs[RoleIDs["EDUCATION"] = 36] = "EDUCATION";
    RoleIDs[RoleIDs["FINANCE"] = 37] = "FINANCE";
    RoleIDs[RoleIDs["CS_AGENT"] = 38] = "CS_AGENT";
    RoleIDs[RoleIDs["CS_READ_ONLY"] = 39] = "CS_READ_ONLY";
    RoleIDs[RoleIDs["CS_BASIC_ACCESS"] = 40] = "CS_BASIC_ACCESS";
    RoleIDs[RoleIDs["LIVE_B2B"] = 41] = "LIVE_B2B";
    RoleIDs[RoleIDs["LIVE_TEACHER"] = 42] = "LIVE_TEACHER";
    RoleIDs[RoleIDs["LIVE_B2C"] = 43] = "LIVE_B2C";
    RoleIDs[RoleIDs["MNO_USER"] = 44] = "MNO_USER";
    RoleIDs[RoleIDs["NEW_INSTITUTION_USER"] = 45] = "NEW_INSTITUTION_USER";
    RoleIDs[RoleIDs["CORRECTION_BOT"] = 46] = "CORRECTION_BOT";
})(RoleIDs || (RoleIDs = {}));
// List of roles giving some sort of premium access
var PremiumAndProRoleIDs = [
    RoleIDs.B2B,
    RoleIDs.PREMIUM_STANDARD,
    RoleIDs.PREMIUM_PLUS,
];
// List of premium roles that are B2C subscription-related
var PremiumSubscriptionRoleIDs = [
    RoleIDs.PREMIUM_STANDARD,
    RoleIDs.PREMIUM_PLUS,
];

var USER_MOCK = {
    about_me: null,
    access: {
        tier: 'plus',
    },
    access_token: 'jfeiofgjoi',
    advocate_id: '12345678',
    apple_user_id: null,
    avatar: 'https://dkiiqzqghqrn.cloudfront.net/files/pictures/picture-42093582_cr_1486981487.png',
    avatar_variations: {
        '500_500': 'https://dkiiqzqghqrn.cloudfront.net/files/imagecache/500x500/files/pictures/picture-42093582_cr_1486981487.png',
        large: 'https://dkiiqzqghqrn.cloudfront.net/files/imagecache/180x180/files/pictures/picture-42093582_cr_1486981487.png',
        original: 'https://dkiiqzqghqrn.cloudfront.net/files/imagecache/500x500/files/pictures/picture-42093582_cr_1486981487.png',
        small: 'https://dkiiqzqghqrn.cloudfront.net/files/imagecache/user_image_default/files/pictures/picture-42093582_cr_1486981487.png',
    },
    best_corrections_awarded: 0,
    birthday: null,
    checklist_complete: true,
    city: null,
    corrections_done: 0,
    country: 'Espagne',
    country_code: 'ES',
    course_access: {
        travel: false,
        business: [],
        mobile: [],
    },
    created: 1484820877,
    currency_code: 'EUR',
    current_course_pack: 'course_pack_en_advanced_english',
    email: 'liam@busuu.com',
    exercises_done: 1,
    fb_uid: null,
    first_name: 'anonymous',
    flag: 'https://cdn.busuu.com/assets/8f5f0ae2/images/flags/ES.png',
    free_trial_eligible: true,
    friends: 1,
    g_uid: null,
    has_avatar: true,
    hashed_email: 'gjeoisjgiesojgoeisgs',
    institution: {
        available_live_lessons: null,
        name: 'busuu',
        internal_name: 'busuu',
        institution_role: 'student',
        institution_id: 1,
        institution_user_id: 123,
        is_competition: true,
        live_lessons_per_month: null,
        specific_content: true,
    },
    institutions: [
        {
            available_live_lessons: null,
            name: 'busuu',
            internal_name: 'busuu',
            institution_role: 'student',
            institution_id: 1,
            institution_user_id: 123,
            is_competition: true,
            live_lessons_per_month: null,
            specific_content: true,
        },
    ],
    is_friend: null,
    is_premium: true,
    languages: {
        interface: 'fr',
        learning_default: 'en',
        learning: {
            es: 'beginner',
            en: 'beginner',
        },
        spoken: {},
    },
    last_access: 1638981397,
    last_login: 1638980043,
    league_id: '62d52dd1-c734-475b-9a63-ef6172f664e5',
    name: 'Liam',
    notification_correction_added: true,
    notification_correction_received: true,
    notification_correction_replies: true,
    notification_correction_requested: true,
    notification_friend_replied: true,
    notification_friend_requested: true,
    notification_leaderboard: true,
    notification_mute_all: false,
    notification_study_plan: true,
    occupation: null,
    opt_in_promotions: true,
    phone_data: {
        numeric_country_code: 44,
        country_code: 'GB',
        phone_number: '7733263485',
        msisdn: '447733263485',
    },
    placement_chooser: false,
    placement_test_available: {
        de: false,
        es: false,
        fr: false,
        it: true,
        pt: false,
        en: false,
    },
    premium_data: {
        product: null,
        created: null,
        started: null,
        next_charge: null,
        expiration: null,
        cancelled: null,
        current_plan: null,
        free_trial: {
            free_trial: true,
        },
        in_app_cancellation: false,
        market: null,
        partner: null,
        partner_metadata: null,
        platform: null,
        productId: null,
        subscriptionId: null,
        subscriptionType: null,
        subscription_status: 'no_active_subscription',
        suspended_plan: null,
        type: null,
        upgrade_plan: null,
    },
    premium_provider: null,
    private_mode_friend_requested: false,
    profile_name: 'Liam',
    referral_token: 'bjFBMUllUm0yYnc9',
    referral_url: 'https://get.busuu.com/bjFBMUllUm0yYnc9',
    roles: [4, 6, 25, 29],
    shadow_ban: false,
    spoken_language_chosen: false,
    thumbs: {
        made: 0,
        received: 0,
        total: 0,
        percentage: 0,
        likes_received: 0,
    },
    timezone: '+01:00',
    uid: 123,
    unique_username: null,
    uuid: 'fjseiojgoiesjigse',
    verbling_user_id: null,
};

export { PremiumAndProRoleIDs, PremiumSubscriptionRoleIDs, RoleIDs, USER_MOCK, getFreeTrialReferrerId, isEligibleForReferralFreeTrial };
//# sourceMappingURL=index.esm.js.map
